import { translate } from '@jsverse/transloco';

export const getTippingIndexOptions = () => [
  {
    value: 0,
    label: translate('weather.weather.tippingIndex0Label'),
    description: '',
  },
  {
    value: 1,
    label: translate('weather.weather.tippingIndex1Label'),
    description: translate('weather.weather.tippingIndex1Description'),
  },
  {
    value: 2,
    label: translate('weather.weather.tippingIndex2Label'),
    description: translate('weather.weather.tippingIndex2Description'),
  },
  {
    value: 3,
    label: translate('weather.weather.tippingIndex3Label'),
    description: translate('weather.weather.tippingIndex3Description'),
  },
  {
    value: 4,
    label: translate('weather.weather.tippingIndex4Label'),
    description: translate('weather.weather.tippingIndex4Description'),
  },
  {
    value: 5,
    label: translate('weather.weather.tippingIndex5Label'),
    description: translate('weather.weather.tippingIndex5Description'),
  },
  {
    value: 6,
    label: translate('weather.weather.tippingIndex6Label'),
    description: translate('weather.weather.tippingIndex6Description'),
  },
  {
    value: 7,
    label: translate('weather.weather.tippingIndex7Label'),
    description: translate('weather.weather.tippingIndex7Description'),
  },
  {
    value: 8,
    label: translate('weather.weather.tippingIndex8Label'),
    description: translate('weather.weather.tippingIndex8Description'),
  },
  {
    value: 9,
    label: translate('weather.weather.tippingIndex9Label'),
    description: translate('weather.weather.tippingIndex9Description'),
  },
  {
    value: 10,
    label: translate('weather.weather.tippingIndex10Label'),
    description: translate('weather.weather.tippingIndex10Description'),
  },
];
